/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Create_SubtitleInputs */

const en_resumes_create_subtitle = /** @type {(inputs: Resumes_Create_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start from scratch or import an existing one`)
};

const de_resumes_create_subtitle = /** @type {(inputs: Resumes_Create_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von Grund auf neu beginnen oder einen bestehenden importieren`)
};

const fr_resumes_create_subtitle = /** @type {(inputs: Resumes_Create_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commence de zéro ou importe un CV existant`)
};

const es_resumes_create_subtitle = /** @type {(inputs: Resumes_Create_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empiece desde cero o importe uno existente`)
};

const it_resumes_create_subtitle = /** @type {(inputs: Resumes_Create_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia da zero o importa uno esistente`)
};

const nl_resumes_create_subtitle = /** @type {(inputs: Resumes_Create_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin vanaf nul of importeer een bestaand CV`)
};

const pl_resumes_create_subtitle = /** @type {(inputs: Resumes_Create_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij od zera lub zaimportuj istniejące`)
};

const fi_resumes_create_subtitle = /** @type {(inputs: Resumes_Create_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita tyhjästä tai tuo olemassa oleva`)
};

const da_resumes_create_subtitle = /** @type {(inputs: Resumes_Create_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start fra bunden eller importer et eksisterende`)
};

const sv_resumes_create_subtitle = /** @type {(inputs: Resumes_Create_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Börja från grunden eller importera ett befintligt`)
};

/**
* | output |
* | --- |
* | "Start from scratch or import an existing one" |
*
* @param {Resumes_Create_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_create_subtitle = /** @type {((inputs?: Resumes_Create_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Create_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_create_subtitle(inputs)
	if (locale === "fr") return fr_resumes_create_subtitle(inputs)
	if (locale === "es") return es_resumes_create_subtitle(inputs)
	if (locale === "it") return it_resumes_create_subtitle(inputs)
	if (locale === "nl") return nl_resumes_create_subtitle(inputs)
	if (locale === "pl") return pl_resumes_create_subtitle(inputs)
	if (locale === "fi") return fi_resumes_create_subtitle(inputs)
	if (locale === "da") return da_resumes_create_subtitle(inputs)
	if (locale === "sv") return sv_resumes_create_subtitle(inputs)
	return en_resumes_create_subtitle(inputs)
});